import { useEffect } from 'react';

/**
 * Locks body scroll when a modal/bottom-sheet is open.
 * Works reliably on iOS Safari by using position:fixed on body
 * and restoring scroll position on unlock.
 *
 * Reference-counted: se più modali/sheet sono aperti contemporaneamente
 * (es. dettaglio badge sopra "Vedi tutto"), il body resta bloccato finché
 * l'ULTIMO si chiude, e la posizione di scroll ripristinata è quella
 * salvata dal PRIMO. Per un singolo modale il comportamento è invariato.
 *
 * Usage: useScrollLock(isOpen)
 */

let lockCount = 0;
let savedScrollY = 0;

function applyLock() {
  if (lockCount === 0) {
    savedScrollY = window.scrollY;
    const body = document.body;
    const html = document.documentElement;

    body.style.position = 'fixed';
    body.style.top = `-${savedScrollY}px`;
    body.style.left = '0';
    body.style.right = '0';
    body.style.overflow = 'hidden';
    // Prevent iOS rubber-band on html element too
    html.style.overflow = 'hidden';
  }
  lockCount += 1;
}

function releaseLock() {
  lockCount = Math.max(0, lockCount - 1);
  if (lockCount === 0) {
    const body = document.body;
    const html = document.documentElement;

    body.style.position = '';
    body.style.top = '';
    body.style.left = '';
    body.style.right = '';
    body.style.overflow = '';
    html.style.overflow = '';

    // Restore scroll position (quella del primo lock)
    window.scrollTo(0, savedScrollY);
  }
}

export function useScrollLock(isLocked) {
  useEffect(() => {
    if (!isLocked) return undefined;
    applyLock();
    return releaseLock;
  }, [isLocked]);
}
